<div class="page-title-area">
    <img src="assets/images/program_apple.jpg" alt="Page Background" class="page-bg" style="width: 100%; height: 100%;">
    <!-- <button class="back-arrow-btn" (click)="navigateToHome()">
        <i class="fas fa-chevron-left fa-2x"></i>
    </button> -->
    <div class="container">
        <div class="section-title program-title" style="text-align: left;">
            <h2 style="color: red !important; font-weight: 500;">Mac for Developers</h2>
            <h4 style="font-weight: 200; max-width: 90%;">Supercharge your code with the Mac for Developers Program—designed to make development smoother, faster, and smarter. Our all-in-one support model helps you handle every challenge while making the most of the Mac advantage. Let's build what's next, together</h4>
            <!-- <p>Supercharge your code with the Mac for Developers Program—designed to make development smoother, faster, and smarter. Our all-in-one support model helps you handle every challenge while making the most of the Mac advantage. Let's build what's next, together.</p> -->
        </div>
    </div>

</div>


<section class="services-details-area ptb-100" id="apple-program-section"
    style="background-color: #f5f5f5;text-align: center;">
    <div class="container">
        <div class="row">
            <h2>Designed to <span style="color: red;">Create</span>. Perfected for <span
                    style="color: red;">Developers</span></h2>
            <img src="assets/images/applelatest.png" alt="Page Background" width="50%" height="50%">
        </div>
        <br>
        <br>
            <div class="cardsflip">
                <div class="flip-card-container">
                    <div class="flip-card">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <img src="assets/images/maintenance.png" alt="Performance">
                                <h2 style="font-weight: 400;">Performance</h2>
                            </div>
                            <div class="flip-card-back">
                                <h3>Performance</h3>
                                <ul class="feature-list">
                                    <li>Fast compile times and seamless multitasking</li>
                                    <li>Optimised for Xcode, Swift, and other dev tools</li>
                                    <li>Handles resource-intensive tasks with ease</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flip-card-container">
                    <div class="flip-card">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <img src="assets/images/battery.png" alt="throttled">
                                <h2 style="font-weight: 400;">All-Day Un-throttled CPU</h2>
                            </div>
                            <div class="flip-card-back">
                                <h3>All-Day Un-throttled CPU</h3>
                                <ul class="feature-list">
                                    <li>Sustained performance without thermal throttling</li>
                                    <li>Ideal for long coding or testing sessions</li>
                                    <li>Delivers consistent power, even on battery</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flip-card-container">
                    <div class="flip-card">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <img src="assets/images/secure-shield.png" alt="Compatibility">
                                <h2 style="font-weight: 400;">Compatibility</h2>
                            </div>
                            <div class="flip-card-back">
                                <h3>Compatibility</h3>
                                <ul class="feature-list">
                                    <li>Native support for popular languages and frameworks</li>
                                    <li>Runs macOS, Linux (via virtualisation), and cross-platform toolss</li>
                                    <li>Supports iOS, iPadOS, macOS, and web development</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flip-card-container">
                    <div class="flip-card">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <img src="assets/images/software-application.png" alt="Display">
                                <h2 style="font-weight: 400;">Display</h2>
                            </div>
                            <div class="flip-card-back">
                                <h3>Display</h3>
                                <ul class="feature-list">
                                    <li>Stunning Retina display with high color accuracy</li>
                                    <li>Ideal for UI/UX design, debugging visuals, and detailed code</li>
                                    <li>Extended display support for multi-screen setups</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flip-card-container">
                    <div class="flip-card">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <img src="assets/images/fan-heater.png" alt="Silent Fan">
                                <h2 style="font-weight: 400;">Silent Fan</h2>
                            </div>
                            <div class="flip-card-back">
                                <h3>Silent Fan</h3>
                                <ul class="feature-list">
                                    <li>Whisper-quiet operation, even under heavy load</li>
                                    <li>Focus-friendly work environment</li>
                                    <li>Passive cooling on M-series MacBooks = zero distraction</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flip-card-container">
                    <div class="flip-card">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <img src="assets/images/system.png" alt="Expert Care">
                                <h2 style="font-weight: 400;">Expert Care</h2>
                            </div>
                            <div class="flip-card-back">
                                <h3>Expert Care</h3>
                                <ul class="feature-list">
                                    <li>Apple Certified technician help when you need it.</li>
                                    <li>Priority repairs and on-site assistance.</li>
                                    <li>From setup to upgrades, we've got you covered</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</section>

<section class="services-details-area ptb-100">
    <section class="features-section">
        <div class="container">
            <h2>Key Benefits for Developers</h2>
            <br>
            <br>
            <div class="features-container">
                <div class="feature-card">
                    <div class="feature-image">
                        <i class="fas fa-clipboard-check fa-4x" style="color: #ff0000;"></i>
                    </div>
                    <div class="feature-content" style="text-align: left;">
                        <h3>IT Readiness Assessment</h3>
                        <p>Evaluate your current infrastructure to ensure smooth Apple integration and identify optimisation opportunities.</p>
                    </div>
                </div>

                <div class="feature-card">
                    <div class="feature-image">
                        <i class="fas fa-hand-holding-usd fa-4x" style="color: #ff0000;"></i>
                    </div>
                    <div class="feature-content" style="text-align: left;">
                        <h3>Flexible Ownership Models</h3>
                        <p>Choose from smart financing and leasing options to make scaling with Apple devices simple and affordable</p>
                    </div>
                </div>

                <div class="feature-card">
                    <div class="feature-image">
                        <i class="fas fa-laptop fa-4x" style="color: #ff0000;"></i>
                    </div>
                    <div class="feature-content" style="text-align: left;">
                        <h3>Try Before You Deploy</h3>
                        <p>Experience real-world Apple solutions with a hands-on demo customised for your business workflows.</p>
                    </div>
                </div>

                <div class="feature-card">
                    <div class="feature-image">
                        <i class="fas fa-headset fa-4x" style="color: #ff0000;"></i>
                    </div>
                    <div class="feature-content" style="text-align: left;">
                        <h3>Enterprise-Grade Support Coverage</h3>
                        <p>Get priority repairs, on-site service, and expert phone support to keep your Apple fleet running flawlessly</p>
                    </div>
                </div>

                <div class="feature-card">
                    <div class="feature-image">
                        <i class="fas fa-magic fa-4x" style="color: #ff0000;"></i>
                    </div>
                    <div class="feature-content" style="text-align: left;">
                        <h3>Effortless Setup with Zero-Touch</h3>
                        <p>Deploy Apple devices straight out of the box—automatically configured and ready to use without IT intervention</p>
                    </div>
                </div>

                <div class="feature-card">
                    <div class="feature-image">
                        <i class="fas fa-user-tie fa-4x" style="color: #ff0000;"></i>
                    </div>
                    <div class="feature-content" style="text-align: left;">
                        <h3>Exclusive Employee Benefits</h3>
                        <p>Empower your teams with discounted Apple products through our organisation-backed purchase program</p>
                    </div>
                </div>

                <div class="feature-card">
                    <div class="feature-image">
                        <i class="fas fa-graduation-cap fa-4x" style="color: #ff0000;"></i>
                    </div>
                    <div class="feature-content" style="text-align: left;">
                        <h3>Training & Enablement</h3>
                        <p>Equip your IT teams and end-users with targeted training on macOS, iOS, and Apple tools for maximum productivity</p>
                    </div>
                </div>

                <div class="feature-card">
                    <div class="feature-image">
                        <i class="fas fa-code-branch fa-4x" style="color: #ff0000;"></i>
                    </div>
                    <div class="feature-content" style="text-align: left;">
                        <h3>Bridge to Apple's Developer Ecosystem</h3>
                        <p>Fast-track innovation by linking directly with Apple's WWDR resources, tools, and community support</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>


<div class="container mb-4">
    <div class="d-flex justify-content-end">
        <button class="btn back-btn" (click)="navigateToHome()">
            <i class="fas fa-arrow-left me-2"></i> Back to Home
        </button>
    </div>
</div>
